export default __webpack_public_path__ + "static/media/inta.9cf93124.png";